import gql from 'graphql-tag';

export const ADMIN_DASHBOARD_DATA = gql`
  query AdminDashboardDAta($input: DashboardOrdersStatsInput) {
    dashboardOrdersStats(input: $input) {
      ordersList {
        id
        order {
          user {
            id
            firstName
            lastName
          }
        }
        totalPaid
        canceled
        stallsStats {
          id
          orderId
          price
          name
          nightly
          qty
          stockQty
          total
        }
        rvsStats {
          id
          orderId
          price
          name
          nightly
          qty
          stockQty
          total
        }
        addOnsStats {
          id
          orderId
          price
          name
          qty
          total
        }
      }
      event {
        id
        startDate
        endDate
        name
      }
      stallsSummary {
        id
        price
        name
        nightly
        qty
        stockQty
        revenue
        discountApplied
        discountRate
        discountStartDate
        discountEndDate
        totalDiscountAmount
        originalRevenue
      }
      rvsSummary {
        id
        price
        name
        nightly
        qty
        stockQty
        revenue
        discountApplied
        discountRate
        discountStartDate
        discountEndDate
        totalDiscountAmount
        originalRevenue
      }
      addOnsSummary {
        id
        price
        name
        qty
        revenue
      }
      refundsSummary {
        id
        payments {
          id
          createdAt
          amount
          notes
        }
      }
      inventorySummary {
        id
        name
        type
        stockQty
        flip
        dailyInventory {
          date
          available
          used
          assigned
        }
      }
      miscChargesSummary {
        id
        amount
        notes
        createdAt
      }
      cancellationRevenue
      error
    }
  }
`;
